




























































































































































































































































import Vue from 'vue';
import moment from 'moment-timezone';
import _ from 'lodash';

import { DppFinal, SexoBebe } from '../../../../back/src/types';
import { Gestacao } from '../../../../back/src/entity/Gestacao';
import { Paciente } from '../../../../back/src/entity/Paciente';
import { sexoBebeStrings, avisosGestacao } from '../../utils/constants';

import IfEmptyTextPrintNA from '../IfEmptyTextPrintNA.vue';
import { calculoIdadeGestacional, calculaImc } from '../../utils/functions';

export default Vue.extend({
  name: 'TheGestacoesDados',
  components: {
    IfEmptyTextPrintNA,
  },
  props: {
    gestacao: {
      type: Object as () => Gestacao,
    },
    paciente: {
      type: Object as () => Paciente,
    },
  },
  data() {
    return {
      avisosGestacao,
      showDados: true,
    };
  },
  computed: {
    vRowClass(): string {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 'd-flex flex-column';
      }
      return '';
    },
    idadeGestacional(): string {
      return calculoIdadeGestacional(this.gestacao, null, true);
    },
    dppFinalLabel(): string {
      if (this.gestacao.dpp_final === DppFinal.M) {
        return '(a partir da DUM)';
      }
      if (this.gestacao.dpp_final === DppFinal.U) {
        return '(US)';
      }
      return '';
    },
    dppFinal(): string {
      if (this.gestacao.dpp_final === DppFinal.M) {
        if (!this.gestacao.data_ultima_menstruacao) {
          return '';
        }
        const momentDate = moment(this.gestacao.data_ultima_menstruacao).add(40, 'w');
        if (!momentDate.isValid()) {
          return 'DPP inválida';
        }
        return momentDate.utc().format('DD/MM/YYYY');
      }
      if (this.gestacao.dpp_final === DppFinal.U) {
        if (!this.gestacao.data_provavel_parto_us) {
          return '';
        }
        const momentDate = moment(this.gestacao.data_provavel_parto_us);
        if (!momentDate.isValid()) {
          return 'DPP inválida';
        }
        return momentDate.utc().format('DD/MM/YYYY');
      }
      return '';
    },
    dataUltimaMenstruacaoFormatada(): string {
      const momentDate = moment(this.gestacao.data_ultima_menstruacao);
      if (momentDate.isValid()) {
        return momentDate.utc().format('DD/MM/YYYY');
      }
      return '';
    },
    dataExameUsFormatada(): string {
      const momentDate = moment(this.gestacao.data_exame_us);
      if (momentDate.isValid()) {
        return momentDate.utc().format('DD/MM/YYYY');
      }
      return '';
    },
    igExameUs(): string {
      if (this.gestacao.ig_exame_us_dias) {
        return `
          ${Math.floor(this.gestacao.ig_exame_us_dias / 7)}
          ${this.gestacao.ig_exame_us_dias % 7}/7
        `;
      }
      return '';
    },
    dataExameUsLaudo(): string {
      if (this.dataExameUsFormatada) {
        return `${this.dataExameUsFormatada} - IG ${this.igExameUs}`;
      }
      return '';
    },
    dataProvavelPartoUsFormatada(): string {
      const momentDate = moment(this.gestacao.data_provavel_parto_us);
      if (momentDate.isValid()) {
        return momentDate.utc().format('DD/MM/YYYY');
      }
      return '';
    },
    alturaM(): string {
      if (this.paciente.altura_cm) {
        const alturaM = this.paciente.altura_cm / 100;
        return `${new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(alturaM)} m`;
      }
      return '';
    },
    pesoInicialKg(): string {
      if (this.gestacao.peso_inicial_gramas) {
        const pesoInicialKg = this.gestacao.peso_inicial_gramas / 1000;
        return `${new Intl.NumberFormat('pt-BR', {
          minimumFractionDigits: 1,
        }).format(pesoInicialKg)} kg`;
      }
      return '';
    },
    gestacaoGemelarObs(): string {
      if (this.gestacao.gestacao_gemelar && this.gestacao.gestacao_gemelar_obs) {
        return ` (${this.gestacao.gestacao_gemelar_obs})`;
      }
      return '';
    },
  },
  methods: {
    calculaImc,
    sexoBebe(sexoBebe: SexoBebe): string {
      if (_.has(sexoBebeStrings, sexoBebe)) {
        return sexoBebeStrings[sexoBebe];
      }
      return '';
    },
  },
});
